module.exports = "img/typing.4cbf14f.png";